export const USER_AUTHENTICATING_STRING = {
  STRING: "0",
};
